<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2"><em>This story is dedicated to my mother</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CityBoy_dedi-1.vue?779aa17f